<template>
    <div>
        <div class="title">{{$t('closed.message')}} <span style="border-bottom:8px solid white;"> {{$t('closed.closed')}}</span>.
        </div>
        <img class="status-icon" src="../../assets/clock.svg"/>

        <div class="info">
            <div class="action">{{ $t('closed.callToAction') }}</div>
            <div class="hours">
                <div v-for="day in weekdays" :key="day" class="line">
                    <div class="day">{{ $t(getDay(day)) }}</div>
                    <div class="times" v-html="renderHours(day)"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Closed',
    data() {
      return {
        weekdays: []
      };
    },

    computed: {
      hours() {
        return this.$store.getters['hours/openingHours'];
      }
    },

    mounted() {
      this.orderWeekdays();
    },

    methods: {
      orderWeekdays() {
        let weekdays = moment.weekdays().map(d => d.toLowerCase());
        for (let i = 0; i < weekdays.indexOf(this.$store.getters['hours/weekStart']); i++) {
          weekdays.push(weekdays.shift());
        }
        this.weekdays = weekdays;
      },

      getDay(day) {
        return 'general.days.' + day;
      },

      renderHours(day) {
        let hours = this.hours[day].sort((a, b) => {
          return a.opening_time > b.opening_time ? 0 : -1;
        });

        let formatted = '';

        // Check actual closed state.
        for (let i = 0; i < hours.length; i++) {
          if (!hours[i].opening_time && !hours[i].closing_time) continue;
          formatted += `${hours[i].opening_time.slice(0, -3)} - ${hours[i].closing_time.slice(0, -3)} <br/>`;
        }

        return formatted === '' ? this.$t('general.closed') : formatted;
      }
    },
  };
</script>

<style scoped lang="scss">

    .info {
        font-size: 1.5em;
        display: flex;
        flex-flow: row nowrap;
        width: 768px;
        max-width: calc(100% - 2rem);
        box-sizing: border-box;
        margin: 0 auto;
        text-align: left;

        div {
            flex: 1;
            flex-shrink: 0;
        }

        .action {
            font-size: 1.25em;
        }

        .hours {
            font-size: 1em;
            font-weight: 600;
            position: relative;
        }

        .line {
            display: flex;
            flex-flow: row nowrap;
            width: 400px;
            margin: 0 auto 1rem;

            div {
                flex: 1;
                text-align: left;
            }
        }
    }
</style>